<template>
  <modal
    :isShow.sync="form.rejectlineDialog"
    title="驳回"
    :isShowBtn="form.isShowBtn"
    :loading="form.loading"
    :btnText="form.ordinaryBtnText"
    @clickHandler="handleClick"
    class="reject-dialog"
  >
    <el-form :rules="rules" :model="form" label-width="100px">
      <el-form-item label="驳回理由" class="freezeDom" prop="rejectReasons">
        <el-input
          size="small"
          type="textarea"
          placeholder="请输入驳回理由，不超过200字"
          v-model="form.rejectReasons"
          maxlength="200"
          show-word-limit
          class="freezeInp"
        >
        </el-input>
      </el-form-item>
    </el-form>
  </modal>
</template>

<script>
import modal from "@/components/modal";

export default {
  name: "rejectModal",
  props: ['rejectForm'],
  data() {
    return {
      rules: {
        rejectReasons: [ { required: true, message: '请输入驳回理由', trigger: 'blur' } ],
      },
    };
  },
  computed: {
    form: {
      get() {
        return this.rejectForm
      },
      set(val) {
        this.$emit('update:rejectForm',val)
      }
    }
  },
  components: {
    modal
  },
  methods: {
    handleClick(arg) {
      this.$emit('rejectClickHandler',arg)
    }
  }
}
</script>

<style scoped lang="scss">
.reject-dialog{
  z-index: 999;
}
.freezeDom {
  margin-top: 30px;

  .freezeInp {
    max-height: 130px;
    max-width: 276px;

  // overflow: hidden;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  .mar-top30 {
    margin-top: 30px;
  }
}
</style>
